const model = {
  text_description: {
    name: "описание",
    sex: 0,
    required: true,
    checkLength: false
  },
  text_name: {
    name: "метка",
    sex: 2,
    required: true,
    checkLength: false
  },
  field_data: {
    name: "источник данных",
    sex: 1,
    required: false,
    checkLength: false
  },
  is_block: {
    name: "блок",
    sex: 1,
    required: false,
    checkLength: false,
    isBoolean: true
  },
  is_block_array: {
    name: "массив блоков",
    sex: 1,
    required: false,
    checkLength: false,
    isBoolean: true
  },
  content_block: {
    name: "контент",
    sex: 1,
    required: false,
    checkLength: false
  },
  format: {
    name: "формат",
    sex: 1,
    required: false,
    checkLength: false
  },
  code: {
    name: "код",
    sex: 1,
    required: false,
    checkLength: false
  }
};

module.exports = model;
